"use client";

import { useCallback } from "react";

import { useVideoPlayer } from "@/contexts/video-player-context";

import type { PlaylistTrack } from "./use-track-video-playlist";

interface TrackVideoPlayerControlsOptions {
  playlist: PlaylistTrack[];
  artistName: string | null;
  source?: { title: string; url: string } | null;
  onPlayAll?: () => void;
}

export function useTrackVideoPlayerControls({
  playlist,
  artistName,
  source,
  onPlayAll,
}: TrackVideoPlayerControlsOptions) {
  const { play } = useVideoPlayer();

  const playByYoutubeId = useCallback(
    (youtubeId: string) => {
      const index = playlist.findIndex((track) => track.youtubeId === youtubeId);
      if (index < 0) return;
      play({ playlist, startIndex: index, artistName, source });
    },
    [playlist, play, artistName, source],
  );

  const playAll = useCallback(() => {
    if (playlist.length === 0) return;
    play({ playlist, startIndex: 0, artistName, source });
    onPlayAll?.();
  }, [playlist, play, artistName, source, onPlayAll]);

  return {
    playAll,
    playByYoutubeId,
    hasPlayableTracks: playlist.length > 0,
  };
}
